import React from 'react';
import { Row, FormGroup, Input, InputGroup, InputGroupAddon, InputGroupText, Col } from 'reactstrap';
import { UnitInfo, UnitInfoSectionProps } from '../interfaces/unit.interface';

// ============ SHARED COMPONENTS ============
interface FieldProps {
  label: string;
  type?: string;
  placeholder: string;
  value: string | number;
  onChange: (value: string) => void;
  readOnly?: boolean;
  colSize?: string;
  symbolData?: string;
}

const Field: React.FC<FieldProps> = ({ 
  label, 
  type = 'text', 
  placeholder, 
  value, 
  onChange, 
  readOnly = false,
  colSize = '4',
  symbolData
}) => {
  const displayValue = (() => {
    if (type === 'number' && (value === 0 || value === '0')) {
      return '';
    }
    return value;
  })();
  
  // Determinar si el input tiene contenido (excluir ceros para números)
  const hasContent = (() => {
    if (type === 'number') {
      return value !== '' && value !== 0 && value !== '0' && value !== null && value !== undefined;
    }
    return value !== '' && value !== null && value !== undefined;
  })();
  
  // Estilos dinámicos para el input
  const inputStyles = {
    ...(readOnly ? { backgroundColor: '#f8f9fa' } : {}),
    ...(hasContent ? { color: '#000000', fontWeight: '500' } : {})
  };

  return (
    <Col md={colSize} className="mb-3">
      <FormGroup>
        <label className="form-control-label">{label}</label>
        {symbolData ? (
          <InputGroup>
            <InputGroupAddon addonType="prepend">
              <InputGroupText>{symbolData}</InputGroupText>
            </InputGroupAddon>
            <Input
              type={type as any}
              placeholder={placeholder}
              value={displayValue}
              onChange={(e) => onChange(e.target.value)}
              readOnly={readOnly}
              style={inputStyles}
            />
          </InputGroup>
        ) : (
          <Input
            type={type as any}
            placeholder={placeholder}
            value={displayValue}
            onChange={(e) => onChange(e.target.value)}
            readOnly={readOnly}
            style={inputStyles}
          />
        )}
      </FormGroup>
    </Col>
  );
};

interface SectionProps {
  title: string;
  borderColor: string;
  children: React.ReactNode;
  backgroundColor?: string;
}

const Section: React.FC<SectionProps> = ({ 
  title, 
  borderColor, 
  children, 
  backgroundColor = '#f8f9fa' 
}) => (
  <div style={{
    border: '1px solid #dee2e6',
    borderRadius: '8px',
    padding: '20px',
    marginTop: '20px',
    backgroundColor
  }}>
    <h5 style={{
      marginBottom: '20px',
      color: '#495057',
      borderBottom: `2px solid ${borderColor}`,
      paddingBottom: '8px'
    }}>
      {title}
    </h5>
    {children}
  </div>
);

// ============ MAIN COMPONENT ============
const UnitInformationQuotationComponent: React.FC<UnitInfoSectionProps> = ({ 
  unitInfo, 
  symbolData, 
  onUnitChange 
}) => (
  <Section title="Información de la Unidad" borderColor="#6f42c1">
    <Row>
      <Field
        label="Nombre del proyecto"
        placeholder="Ingrese el nombre del proyecto"
        value={unitInfo.projectName}
        onChange={(v) => onUnitChange('projectName', v)}
        colSize="6"
      />
      <Field
        label="Nombre de la unidad"
        placeholder="Ingrese el nombre de la unidad"
        value={unitInfo.unitName}
        onChange={(v) => onUnitChange('unitName', v)}
        colSize="6"
      />
    </Row>
    <Row>
      <Field
        label="Precio base"
        type="number"
        placeholder="0"
        value={unitInfo.basePrice}
        onChange={(v) => onUnitChange('basePrice', v)}
        symbolData={symbolData}
        colSize="6"
      />
      <Field
        label="Vista"
        placeholder="Ej: Vista al mar, Vista a la montaña, Vista urbana"
        value={unitInfo.unitView}
        onChange={(v) => onUnitChange('unitView', v)}
        colSize="6"
      />
    </Row>
  </Section>
);

export default UnitInformationQuotationComponent;